module.exports = __webpack_public_path__ + "tables/media/light-notify.2467abe4.svg";